import sessionTimer from '@/utils/sessionTimer.js'

export const unlimitedAccess = (to, from, next) => {
  // Session 超时的定时任务
  sessionTimer.startMonitoring()

  // 不能删
  next()
}
